import ErrorModal from './ErrorModal';

export default ErrorModal;
